<template>
  <div id="app">
    <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
      <!-- <component :is="userComponentImstance"></component> -->
      <router-view/>
    <!-- </transition> -->
  </div>
</template>

<script>
import '@/assets/css/base.css'
// import VConsole from 'vconsole';

// var vvcon = new VConsole();
export default {
  name: 'app',
  computed: {
	// 	userComponentImstance() {
	// 		return () => import('./pages/index.vue');
	// 	}
  }
}
</script>